import AvailabilityInfo from "@/pages/medewerkers/$userId/beschikbaarheid/AvailabilityInfo"
import { useAuthStore } from "@/stores/useAuthStore"
import { createFileRoute, useRouter } from "@tanstack/react-router"

export const Route = createFileRoute("/profiel/beschikbaarheid/")({
  component: RouteComponent,
})

function RouteComponent() {
  const userFromStore = useAuthStore((state) => state.user)
  const router = useRouter()

  const handleNavigate = () => {
    router.navigate({
      to: "/profiel/beschikbaarheid/invullen",
    })
  }

  return (
    <AvailabilityInfo
      userId={Number(userFromStore?.userId)}
      handleNavigate={handleNavigate}
      pageType="profile"
    />
  )
}
